export const GET_ADDITIONAL_ITEMS_LIST = '/building_additional_items/get_additional_items_list';
export const SHOW_ADDITIONAL_ITEMS_DATA = '/building_additional_items/show_additional_items_data';
export const CREATE_ADDITIONAL_ITEMS_DATA = '/building_additional_items/create_additional_items_data';
export const UPDATE_ADDITIONAL_ITEMS_DATA = '/building_additional_items/update_additional_items_data';
export const GET_FLOOR_AREA = '/building_additional_items/get_floor_area';
export const GET_ACTUAL_USE_LIST = '/building/get_actual_use_list';
export const GET_BUILDING_COMPONENTS = '/building/get_building_components';
export const GET_SINGLE_BUILDING_COMPONENT = '/building/get_single_building_component';
export const GET_SINGLE_BUILDING_APPLICATION = '/building/show_data';

export const FORM_DATA = {
    floor: 0,
    rptax_land_classification_id: '',
    rptax_building_component_id: '',
    area: 0,
    rate: 0,
    is_add_area: 0
};